import React from 'react';

import { Link, graphql, useStaticQuery } from 'gatsby';

import LinkButton from '@/components/Elements/LinkButton/LinkButton';

import { IFooterQuery } from '@/types/types';

import Logo from '@/icons/iflexion-logo.svg';
import UK from '@/icons/uk-icon.svg';
import US from '@/icons/us-icon.svg';

import FooterMobile from './FooterMobile';

import './Footer.scss';

export const query = graphql`
  query FooterQuery {
    services: strapiFooter(title: { eq: "Services" }) {
      ...Footer
    }
    industries: strapiFooter(title: { eq: "Industries" }) {
      ...Footer
    }
    technologies: strapiFooter(title: { eq: "Technologies" }) {
      ...Footer
    }
  }
`;

const Footer = () => {
  const { services, industries, technologies } = useStaticQuery<IFooterQuery>(query);

  return (
    <div className="Footer_container">
      <div className="Footer_top">
        <Link to="/" aria-label="Iflexion" className="Footer_logo-link">
          <Logo className="Footer_logo" />
        </Link>
        <div className="Footer_top-links">
          <LinkButton title="About Iflexion" link="/about" typographyClass="body-3" />
          <LinkButton title="How we work" link="/about/how-we-work" typographyClass="body-3" />
        </div>
      </div>
      <div className="Footer_middle">
        <div className="Footer_contacts">
          <h6>Contacts</h6>
          <div className="Footer_countries_container">
            <div className="Footer_country_block">
              <div className="Footer_country">
                <US />
                <p className="subtitle-3">United States</p>
              </div>
              <p className="body-3 Footer_country_address">
                160 Clairemont Ave, Suite 200,
                <br />
                Decatur, GA 30030 <br /> +1 (720) 207 0369
              </p>
            </div>
            <div className="Footer_country_block">
              <div className="Footer_country">
                <UK />
                <p className="subtitle-3">United Kingdom</p>
              </div>
              <p className="body-3 Footer_country_address">
                3rd floor, 5-8 Dysart Street, London, EC2A 2BX
                <br /> +44 (0) 203 687 2280
              </p>
            </div>
          </div>
        </div>
        <div className="Footer_business-segments">
          <div className="Footer_services">
            <h6>{services.title}</h6>
            <ul className="Footer_services-list">
              {services.items.map((serviceItem) => (
                <li key={serviceItem.id} className="Footer_services-list-item">
                  <Link
                    to={serviceItem.landing?.path || '/'}
                    aria-label={serviceItem.title}
                    className="body-3 Footer_services-link"
                  >
                    {serviceItem.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="Footer_industries-technologies">
            <div className="Footer_industries">
              <h6>{industries.title}</h6>
              <div className="Footer_industries-technologies-links">
                {industries.items.map((industriesItem) => (
                  <Link
                    key={industriesItem.id}
                    to={industriesItem.landing?.path || '/'}
                    aria-label={industriesItem.title}
                    className="Footer_industries-technologies-link medium"
                  >
                    <p className="body-3 Footer_industries-technologies-link-item">{industriesItem.title}</p>
                  </Link>
                ))}
              </div>
            </div>
            <div className="Footer_technologies">
              <h6>{technologies.title}</h6>
              <div className="Footer_industries-technologies-links">
                {technologies.items.map((technologiesItem) => (
                  <Link
                    key={technologiesItem.id}
                    to={technologiesItem.landing?.path || '/'}
                    aria-label={technologiesItem.title}
                    className="Footer_industries-technologies-link medium"
                  >
                    <p className="body-3 Footer_industries-technologies-link-item">{technologiesItem.title}</p>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
        <FooterMobile services={services} industries={industries} technologies={technologies} />
      </div>
      <div className="caption-1 Footer_bottom">
        <p>Copyright 1999 — {new Date().getFullYear()} © Iflexion. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
